var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "text-muted mb-2" }, [
        _vm._v(_vm._s(_vm.$t("stripe_connect.help"))),
      ]),
      !_vm.status
        ? _c(
            "div",
            [
              _c(
                "b-alert",
                {
                  staticClass: "p-1",
                  attrs: { variant: "secondary", show: "" },
                },
                [_vm._v(_vm._s(_vm.$t("stripe_connect.loading")))]
              ),
            ],
            1
          )
        : [
            _c("div", { staticClass: "vx-row mb-1" }, [
              _c(
                "div",
                { staticClass: "vx-col w-full" },
                [
                  _c(
                    "vs-chip",
                    {
                      staticClass: "text-base mr-2",
                      attrs: { transparent: "", color: _vm.statusColor },
                    },
                    [_vm._v(" " + _vm._s(_vm.statusLabel) + " ")]
                  ),
                  _vm.status.external_account_id
                    ? _c("span", { staticClass: "text-muted" }, [
                        _vm._v(_vm._s(_vm.status.external_account_id)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm.pendingRequirements.length
              ? _c("div", { staticClass: "vx-row mb-1" }, [
                  _c(
                    "div",
                    { staticClass: "vx-col w-full" },
                    [
                      _c(
                        "b-alert",
                        {
                          staticClass: "p-1",
                          attrs: { variant: "warning", show: "" },
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("stripe_connect.pending"))),
                          ]),
                          _c(
                            "ul",
                            { staticClass: "mb-0 mt-1" },
                            _vm._l(_vm.pendingRequirements, function (item) {
                              return _c("li", { key: item }, [
                                _vm._v(_vm._s(item)),
                              ])
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c("div", { staticClass: "vx-row" }, [
              _c(
                "div",
                { staticClass: "vx-col w-full flex gap-2" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.legalEntityId,
                      },
                      on: { click: _vm.onboard },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.status.connected
                              ? _vm.$t("stripe_connect.continue")
                              : _vm.$t("stripe_connect.start")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.loadStatus },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("stripe_connect.refresh")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }